import { injectable } from "inversify";
import MasterItemEntity from "../../../domain/entities/master_item.entity";
import MasterDataRepository from "../../../domain/repositories/master_data.repository";

@injectable()
class MasterDataRepositoryFake implements MasterDataRepository {
    getCallTypes = async (): Promise<MasterItemEntity[]> => {
        return [
            { id: "1", name: "Call Type 1" },
            { id: "2", name: "Call Type 2" },
            { id: "3", name: "Call Type 3" },
        ];
    }
}

export default MasterDataRepositoryFake;